import { DEMO_TOKEN, setupDemoAuth } from "../demo/demoAuth";
import { IAuthToken, IDecodeToken } from "../store/reducers/auth";
import jwtDecode from "jwt-decode";

const getTokenInfoFromLocal = () => {
  const token = localStorage.getItem("token") || DEMO_TOKEN;
  const { exp } = jwtDecode<IDecodeToken>(token);
  const expiresInMiliseconds = exp * 1000;
  return {
    token,
    expiresAt: new Date(expiresInMiliseconds),
    milisecondsToExpire: expiresInMiliseconds - Date.now(),
  };
};

const keepSession = () => {};

const login = async (_email: string, _password: string): Promise<IAuthToken> => {
  setupDemoAuth();
  return { Token: DEMO_TOKEN, ExpiresInMin: 99999 };
};

const changePassword = async () => ({ Token: DEMO_TOKEN, ExpiresInMin: 99999 });

const logout = async (_userId?: string) => ({ data: "ok" });

const register = async () => "ok";

export const refreshToken = async () => {
  setupDemoAuth();
};

const setToken = (token: string, _tokenType = "Bearer") => {
  localStorage.setItem("token", token);
};

const revokeToken = () => {
  localStorage.removeItem("token");
};

const remindPassword = async () => ({});

const resetPassword = async () => ({});

const authService = {
  getTokenInfoFromLocal,
  keepSession,
  login,
  resetPassword,
  logout,
  refreshToken,
  register,
  changePassword,
  remindPassword,
  revokeToken,
  setToken,
};

export default authService;
